import * as nodeUtils from "../../abstract/controller/utils/nodeUtils";
import DefaultTooltip from "../ui/tooltips/DefaultTooltip";
import ElementTooltipExpression from "./ElementTooltipExpression";

const _limit = 50;

function TooltipExpression({ node, handle, isHidden }) {
  if (isHidden) {
    return null;
  }

  const _expression = nodeUtils.getExpression(node);

  if (!_expression) {
    return null;
  }

  if (_expression.length < _limit) {
    return null;
  }

  return (
    <DefaultTooltip handle={handle}>
      <ElementTooltipExpression node={node} />
    </DefaultTooltip>
  );
}

export default TooltipExpression;
